"use strict";

module.exports = {

    base_path: '/',

    admin_login_url: '/login/zekkmdvhkm',

    // api_base_url: 'http://localhost:3333/',
    // api_base_url: 'http://69.162.81.82:5001/',//old url
    api_base_url: 'http://79.142.76.220:5212/',//new url

    aws_base_url: 'https://drh6v62agjku8.cloudfront.net',

    node_chat_url: 'http://localhost:3333',

    default_language: 'en',

    api_token: 'api.Pd*!(5675',

    session_key: "SESSION_KEY",

    session_object: "authorization",

    pagination_size: 20,

    client_id: '59200748-36fc-2744-355-8c1281f7fcd2',

    crypto_secret: 'kXp2s5v8y/B?E(H+MbQeThWmZq3t6w9z',
}
